import {Accordion} from "../sf-utils";

export function initGuides() {
	// SF TODO BP: is this needed??
	new Accordion({
		selector: "[data-accordion]",
		single_panel: false
	});
}
